import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/push-notification';

export default {
    subscribe(payload) {
        return axios.post(`${RESOURCE_NAME}/subscribe`, payload)
    },
};